import {Injectable} from '@angular/core';
import {MessageService} from "primeng/api";
import {IToaster, TOAST_KEY} from "./index";
import {Message} from "primeng/api/message";

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  defaultToastInfo: Message = {
    key: TOAST_KEY,
    life: 3000 // After 3 Sec Toaster will disappear
  }

  constructor(public _message: MessageService) {
  }

  /**
   * Success Type : Toaster
   * */
  success(details: IToaster): void {
    this._message.add({
      ...this.defaultToastInfo,
      severity: 'success',
      summary: details.summary,
      detail: details.detail,
      icon: details.icon ? details.icon : 'pi pi-check-circle'
    })
  }

  /**
   * Info Type : Toaster
   * */
  info(details: IToaster): void {
    this._message.add({
      ...this.defaultToastInfo,
      severity: 'info',
      summary: details.summary,
      detail: details.detail,
      icon: details.icon ? details.icon : 'pi pi-info-circle'
    })
  }

  /**
   * Warn Type : Toaster
   * */
  warn(details: IToaster): void {
    this._message.add({
      ...this.defaultToastInfo,
      severity: 'warn',
      summary: details.summary,
      detail: details.detail,
      icon: details.icon ? details.icon : 'pi pi-exclamation-circle'
    })
  }

  /**
   * Error Type : Toaster
   * */
  error(details: IToaster): void {
    this._message.add({
      ...this.defaultToastInfo,
      severity: 'error',
      summary: details.summary,
      detail: details.detail,
      icon: details.icon ? details.icon : 'pi pi-times-circle'
    })
  }

  showInvalidFiles(fileNames: string[], title: string): void {
    const data: any = {
      type: 'invalidFilesList',
      fileNames: fileNames,
      title: title,
      icon: 'pi pi-times-circle'
    };
    this._message.add({
      ...this.defaultToastInfo,
      severity: 'error',
      detail: data.title,
      summary: data.fileNames,
      icon: data.icon
    })
  }
}
